import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { activateAccount } from '../core/_requests'
import { useAuth } from '../core/Auth'
import { LanguageHelp, setLanguage } from '../../../../_metronic/helpers/LanguageHelper'
import { LayoutSplashScreen } from '../../../../_metronic/layout/core'


const activateAccountFunction = async (code: string = LanguageHelp('Last 30 days'), saveAuth: any) => {
  try {
    const { data: auth } = await activateAccount(code)
    if (auth.httpStatusCode === 400) {
      console.error(auth.message)
      saveAuth(undefined);
    }
    else { saveAuth(auth); setLanguage(auth.result.language, false) }
  } catch (error) {
    console.error(error)
  }
}

export function ActivateAccount() {
  const { saveAuth } = useAuth()
  const queryParameters = new URLSearchParams(window.location.search)
  const code = queryParameters.get("c")
  activateAccountFunction(code as string, saveAuth)

  return (
    <div>
      {code === null &&
        <div>
          <div className='mb-10 bg-light-warning p-8 rounded'>
            <div className='text'>{LanguageHelp("Your activation info is wrong. Please contact AISenseUs support team!")}</div>
          </div>
          <div className='text-gray-500 text-center fw-semibold fs-6'>
            {LanguageHelp('Are you a Member?')}{' '}
            <Link to='/auth/login' className='link-primary'>
              {LanguageHelp('Login')}
            </Link>
          </div>
          <div className='text-gray-500 text-center fw-semibold fs-6'>
            {LanguageHelp('Not a Member yet?')}{' '}
            <Link to='/auth/registration' className='link-primary'>
              {LanguageHelp('Sign up')}
            </Link>
          </div>
        </div>
      }
      {code !== null &&
        <LayoutSplashScreen></LayoutSplashScreen>
      }
    </div>
  )
}
